import { render, staticRenderFns } from "./PlayerVideo.vue?vue&type=template&id=f1346bcc&scoped=true"
import script from "./PlayerVideo.vue?vue&type=script&lang=js"
export * from "./PlayerVideo.vue?vue&type=script&lang=js"
import style0 from "./PlayerVideo.vue?vue&type=style&index=0&id=f1346bcc&prod&lang=stylus&scoped=true"
import style1 from "./PlayerVideo.vue?vue&type=style&index=1&id=f1346bcc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1346bcc",
  null
  
)

export default component.exports